import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@driftt/tide'
import EditIcon from 'images/mini_edit_category_icon.svg'
import DeleteIcon from 'images/mini_delete_category_icon.svg'

import cx from 'classnames'

const EditSectionButtons = ({ onEditIconClick, onDeleteIconClick }) => (
  <div className="category-nav-section-icons-wrapper">
    <img className="category-nav-section-icons-edit" onClick={onEditIconClick} src={EditIcon} alt="Edit section"/>
    <img className="category-nav-section-icons-delete" onClick={onDeleteIconClick} src={DeleteIcon} alt="Delete section"/>
  </div>
)

const SectionItem = ({ key, section, parsedSectionId, category, onOpenSidebar, onOpenDeleteModal, onSectionItemClick }) => {
  return (
    <div key={key} className="section-item-wrapper" onClick={onSectionItemClick}>
      <Link
        key={section.id}
        className={cx('category-nav-item category-nav-section', {
          'selected': section.id === parsedSectionId
        })}
        to={`/category/${category.id}/${section.id}`}
      >
        <Icon className="category-nav-section-folder-image" name="section-1"/>
        <div className="category-nav-section-name">{section.name}</div>
        <EditSectionButtons
          onEditIconClick={() => onOpenSidebar(section, 'section')}
          onDeleteIconClick={() => onOpenDeleteModal(section, 'section')}
        />
      </Link>
    </div>
  )
}

export default SectionItem